import type { useRouter } from "next/navigation";

import { signIn } from "@acme/modern-auth/auth-client";

import { env } from "~/env";

const INSTALLATION_URL = `https://github.com/apps/${env.NEXT_PUBLIC_GITHUB_APP_HANDLE}/installations/new`;

const POST_INSTALL_REDIRECT_KEY = "post_github_install_redirect";

export const redirectToGithubInstallation = (
  router: ReturnType<typeof useRouter>,
  currentPathname: string,
) => {
  window.localStorage.setItem(POST_INSTALL_REDIRECT_KEY, currentPathname);
  setTimeout(() => {
    router.push(INSTALLATION_URL);
  }, 10);
};

export const replaceWithPostInstallRedirect = (
  router: ReturnType<typeof useRouter>,
  needsToReauthorize: boolean,
) => {
  const redirectPath = window.localStorage.getItem(POST_INSTALL_REDIRECT_KEY);

  if (needsToReauthorize) {
    void signIn.social({
      provider: "github",
      callbackURL: redirectPath ?? undefined,
    });
  } else {
    if (redirectPath) {
      window.localStorage.removeItem(POST_INSTALL_REDIRECT_KEY);
      router.replace(redirectPath);
    }
  }
};

export const hasPostInstallRedirect = () => {
  if (typeof window === "undefined") {
    // We're on the server, we assume redirect is needed
    return true;
  }

  return Boolean(window.localStorage.getItem(POST_INSTALL_REDIRECT_KEY));
};
